import React, { FC } from 'react';
import styled, { css } from 'styled-components';
import media from '../../../constants/media';
import { StyledRadio, StyledRadioLabel } from './formikRadio';

const StyledWrapper = styled.div`
	width: 100%;

	${media.tablet`
		display: flex;
		align-items: center;
	`};

	${({ colorTheme, theme }) =>
		colorTheme === 'secondary' &&
		css`
			${StyledRadioLabel} {
				color: #fff;
				font-family: ${({ theme: innerTheme }) => innerTheme.fonts.ArimoMedium};
			}

			${StyledRadio} {
				background: #fff;
				:after {
					background-color: ${theme.colors.primary};
				}
			}
		`}
`;

interface Props {
	children: any;
	colorTheme?: 'default' | 'secondary';
}

const FormikRadioWrapper: FC<Props> = ({ children, colorTheme }) => {
	return <StyledWrapper colorTheme={colorTheme}>{children}</StyledWrapper>;
};

export default FormikRadioWrapper;
